import styled from 'styled-components'
import { createCardLayoutStyles } from '~/pages/anatomy/quizBinaryChoice/libs/styles/cardLayout'
import { COLORS } from '~/shared/constants/uiConstants'

export const Styles = createCardLayoutStyles({
  secondBehind: COLORS.PURPLE_100,
  firstBehind: '#ffd387',
  front: '#fdfcf7',
})

// This page's source image has an inconsistent aspect ratio vs. the other
// tab-card screens, so crop it to a fixed frame instead of the default
// natural-height <img>.
export const Image = styled.img`
  aspect-ratio: 4 / 3;
  object-fit: cover;
  border-radius: 10px;
`
